export const API_BASE = process.env.VUE_APP_BASE_URL;
export const API_PATH = process.env.VUE_APP_BASE_PATH;
export const ID_TOKEN_KEY = "id_token";

export const API_URL = API_BASE + API_PATH;
export const BASE_URL = API_BASE;

export const useMock = false;

export const MOCK_API = "";
export const mockURL = MOCK_API;

export const ICON_FILE = require("@/assets/iconfont.js");
